import http from './http.js'

const formHeader={headers: {'Content-Type': 'application/x-www-form-urlencoded'}}

const api={
	
	generateLoginCode:function(data){
		       return new Promise(function (resolve, reject) {
		       http.post('/pc/generateScanCode' ).then(res => {
		                 resolve(res)
		               })

		        })
	},
	
	qrCodeLogin:function(data){
		return new Promise(function (resolve, reject) {
		http.post('/pc/qrCodeLogin',data,formHeader ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	
	chatGpt:function(data){
		return new Promise(function (resolve, reject) {
		http.post('/pc/chatGpt',data,formHeader ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getNoticeList:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/getNoticeList' ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	requestCountByDay:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/requestCountByDay' ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getRequestCount:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/getRequestCount' ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getUserInfo:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/getUserInfo' ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getMenu:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/menu/getMenu' ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getWebsites:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/website/getWebsites', {
  params: data} ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getCommentPage:function(data){
		return new Promise(function (resolve, reject) {
		http.get('/pc/getCommentPage', {
  params: data} ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	
	saveComment:function(data){
		return new Promise(function (resolve, reject) {
		http.post('/pc/saveComment',data,formHeader ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	updateBaseUserInfo:function(data){
		return new Promise(function (resolve, reject) {
		http.post('/pc/updateBaseUserInfo',data ).then(res => {
		          resolve(res)
		        })
		
		 })
	},
	getCommentPage:function(data){
			return new Promise(function (resolve, reject) {
			http.get('/pc/getCommentPage', {
	params: data} ).then(res => {
			          resolve(res)
			        })
			
			 })
		},
		
		getUserWebsitePage:function(data){
				return new Promise(function (resolve, reject) {
				http.get('/pc/userWebsite/getUserWebsitePage', {
		params: data} ).then(res => {
				          resolve(res)
				        })
				
				 })
			},
			saveUserWebsite:function(data){
				return new Promise(function (resolve, reject) {
				http.post('/pc/userWebsite/saveUserWebsite',data ).then(res => {
				          resolve(res)
				        })
				
				 })
				
			},
			queryIpForAddress:function(data){
				return new Promise(function (resolve, reject) {
						http.post('/pc/queryIpForAddress',data,formHeader ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			generateQrCode:function(data){
				return new Promise(function (resolve, reject) {
						http.post('/pc/generateQrCode',data,formHeader ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			logout:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/logout', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			getTop10:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/userSign/getTop10', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			checkUserSign:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/userSign/checkUserSign', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			saveUserSign:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/userSign/saveUserSign', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			getUserSignCount:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/userSign/getUserSignCount', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			getQuestionnairePage:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/questionnaire/getQuestionnairePage', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			saveOrUpdateQuestionnaire:function(data){
				return new Promise(function (resolve, reject) {
						http.post('/pc/questionnaire/saveOrUpdateQuestionnaire', data ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			getQuestionnaire:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/questionnaire/getQuestionnaire', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
			deleteQuestionnaire:function(data){
				return new Promise(function (resolve, reject) {
						http.get('/pc/questionnaire/deleteQuestionnaire', {
				params: data} ).then(res => {
						          resolve(res)
						        })
						
						 })
			},
				
	getQuestionnaireAnswerPage:function(data){
		return new Promise(function (resolve, reject) {
				http.get('/pc/questionnaireAnswer/getQuestionnaireAnswerPage', {
		params: data} ).then(res => {
				          resolve(res)
				        })
				 })
	},
	exportQuestionnaireAnswerData:function(data){				
				return new Promise(function (resolve, reject) {
						http.post('/pc/questionnaireAnswer/exportQuestionnaireAnswerData',data,formHeader ).then(res => {
						          resolve(res)
						        })
						
						 })
				
	},
	getNesGamePage:function(data){
		return new Promise(function (resolve, reject) {
				http.get('/pc/nesGame/getNesGamePage', {
		params: data} ).then(res => {
				          resolve(res)
				        })
				 })
	},
	updateClickCount:function(data){
		return new Promise(function (resolve, reject) {
				http.get('/pc/updateClickCount', {
		params: data} ).then(res => {
				          resolve(res)
				        })
				 })
	}
	
}

export default api